// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"H_X","menu":"H_Y"};